import React, { useEffect, useState } from "react";
import { Alert, Button, Stack, Typography } from "@mui/material";
import { listApifacilCalls, rejectApifacilCall } from "../../api/client";
import { whatsappQrCapabilities } from "../../utils/whatsappQrCapabilities";

const POLL_MS = 15000;

function isCallsDisabledResponse(data, err) {
  if (data?.callsDisabled === true) return true;
  const status = Number(err?.status || err?.response?.status || 0);
  const message = String(err?.message || err?.response?.data?.message || data?.message || "");
  return status === 409 || /nao estao ativas|não estão ativas/i.test(message);
}

export default function WhatsappQrCallBanner({ channelId, version }) {
  const caps = whatsappQrCapabilities(version);
  const [calls, setCalls] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!caps.calls || !channelId) return undefined;
    let cancelled = false;
    let timer = null;
    let disabled = false;

    const stop = () => {
      disabled = true;
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const tick = async () => {
      if (cancelled || disabled) return;
      if (typeof document !== "undefined" && document.visibilityState === "hidden") return;
      try {
        const data = await listApifacilCalls(channelId);
        if (cancelled) return;
        if (isCallsDisabledResponse(data)) {
          setCalls([]);
          stop();
          return;
        }
        setCalls(Array.isArray(data?.chamadas) ? data.chamadas : []);
      } catch (err) {
        if (cancelled) return;
        setCalls([]);
        if (isCallsDisabledResponse(null, err)) stop();
      }
    };

    tick();
    timer = setInterval(tick, POLL_MS);
    const onVis = () => {
      if (typeof document !== "undefined" && document.visibilityState === "visible") tick();
    };
    if (typeof document !== "undefined") {
      document.addEventListener("visibilitychange", onVis);
    }
    return () => {
      cancelled = true;
      stop();
      if (typeof document !== "undefined") {
        document.removeEventListener("visibilitychange", onVis);
      }
    };
  }, [caps.calls, channelId]);

  if (!caps.calls || !calls.length) return null;

  return (
    <Stack spacing={1} sx={{ mb: 1 }}>
      {calls.map((call) => (
        <Alert
          key={call.id}
          severity="info"
          action={
            call.pode_rejeitar !== false ? (
              <Button
                color="inherit"
                size="small"
                disabled={busy}
                onClick={async () => {
                  setBusy(true);
                  try {
                    await rejectApifacilCall(channelId, call.id);
                    setCalls((prev) => prev.filter((c) => c.id !== call.id));
                  } finally {
                    setBusy(false);
                  }
                }}
              >
                Rejeitar
              </Button>
            ) : null
          }
        >
          <Typography variant="body2">
            {call.video ? "Chamada de vídeo" : "Chamada de voz"} {call.estado === "tocando" ? "tocando" : "em andamento"}
            {call.remote_jid ? ` · ${String(call.remote_jid).split("@")[0]}` : ""}
          </Typography>
        </Alert>
      ))}
    </Stack>
  );
}
